// Shared avatar-or-fallback DOM toggle for live chat (chat-panel messages + the pinned-tips
// chip rail). `user` is the payload ChatSenderIdentity serializes (avatar_url, initials,
// avatar_color_class), so both surfaces render the exact same fallback AvatarComponent uses
// elsewhere in the app - no separate color/initials logic lives in JS.
//
// The initials fallback is always rendered first and stays until the photo has actually loaded,
// then the two swap inside the same fixed-size box: no blank circle while the image is in flight
// and no layout shift when it lands.
export function applyAvatar(imgEl, fallbackEl, user) {
  const avatarUrl = user && user.avatar_url;

  showFallback(fallbackEl, user);
  if (!imgEl) return;

  if (!avatarUrl) {
    imgEl.onload = null;
    imgEl.onerror = null;
    imgEl.removeAttribute("src");
    imgEl.classList.add("hidden");
    return;
  }

  imgEl.classList.add("hidden");
  // Handlers check the src they were set for: the confirm dialog reuses one img across previews.
  imgEl.onload = () => {
    if (imgEl.getAttribute("src") !== avatarUrl) return;
    imgEl.classList.remove("hidden");
    hideFallback(fallbackEl);
  };
  imgEl.onerror = () => {
    if (imgEl.getAttribute("src") !== avatarUrl) return;
    imgEl.removeAttribute("src");
    imgEl.classList.add("hidden");
  };
  imgEl.src = avatarUrl;
  // A cached image can be complete synchronously, before load fires.
  if (imgEl.complete && imgEl.naturalWidth > 0) imgEl.onload();
}

function showFallback(fallbackEl, user) {
  if (!fallbackEl) return;

  fallbackEl.textContent = (user && user.initials) || "";
  fallbackEl.classList.remove("hidden");
  fallbackEl.classList.add("flex");

  // fallbackEl may be a persistent element reused across renders (e.g. the chat-panel confirm
  // dialog's preview), not always a fresh template clone - drop whichever color class we
  // applied last time before adding the new one, so colors don't stack up across reuses.
  if (fallbackEl.dataset.avatarColorClass) fallbackEl.classList.remove(fallbackEl.dataset.avatarColorClass);
  if (user && user.avatar_color_class) {
    fallbackEl.classList.add(user.avatar_color_class);
    fallbackEl.dataset.avatarColorClass = user.avatar_color_class;
  } else {
    delete fallbackEl.dataset.avatarColorClass;
  }
}

function hideFallback(fallbackEl) {
  if (!fallbackEl) return;
  fallbackEl.classList.add("hidden");
  fallbackEl.classList.remove("flex");
}
